import { render, staticRenderFns } from "./FlowNodeRemind.vue?vue&type=template&id=51b82705&scoped=true&"
import script from "./FlowNodeRemind.vue?vue&type=script&lang=js&"
export * from "./FlowNodeRemind.vue?vue&type=script&lang=js&"
import style0 from "./FlowNodeRemind.vue?vue&type=style&index=0&id=51b82705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b82705",
  null
  
)

export default component.exports